/* ---- Be Neo — caixa de compra da pagina de produto -----------------------
   Le o mesmo JSON de snippets/lp-offer-data.liquid que as LPs usam, entao
   preco, selling plan e regra de brinde sao os mesmos nos dois lugares: mudou
   no admin, muda aqui e na LP junto, sem deploy.

   O tema Horizon nao tem bloco de selling plan — sem isto a pagina de produto
   simplesmente nao vende assinatura. */
(function () {
  var D = {};                 /* qty -> {variantId, once, plan, planId, days, ship} */
  var GIFTS = [];
  var plan = 'sub', qty = 3;

  function usd(n) { return '$' + n.toFixed(2); }
  function bottles(n) { return n + (n > 1 ? ' bottles' : ' bottle'); }

  function planDays(txt, q) {
    var m = /(\d+)\s*(day|week|month)/i.exec(txt || '');
    if (!m) return q * 30;
    var n = +m[1], u = m[2].toLowerCase();
    return u === 'day' ? n : u === 'week' ? n * 7 : n * 30;
  }

  function read() {
    var el = document.getElementById('lp-offer-data');
    if (!el) return false;
    var raw;
    try { raw = JSON.parse(el.textContent); } catch (e) { return false; }
    if (!raw || !raw.items || !raw.items.length) return false;
    GIFTS = Array.isArray(raw.gifts) ? raw.gifts.filter(function (g) { return g && g.variantId; }) : [];
    raw.items.forEach(function (it) {
      if (!it.qty) return;
      D[it.qty] = {
        variantId: it.variantId,
        once: it.oncePrice / 100,
        ship: parseFloat(it.ship) || 0,
        planId: it.plan ? it.plan.id : null,
        plan: it.plan ? it.plan.price / 100 : null,
        days: it.plan ? planDays(it.plan.every, it.qty) : null
      };
    });
    if (!D[qty] || !D[qty].planId) plan = 'once';
    return true;
  }

  function render() {
    var d = D[qty];
    if (!d) return;
    var total = plan === 'sub' && d.plan != null ? d.plan : d.once;
    var useDays = qty * 30;                   /* dias de uso, para o "por dia" */

    document.querySelectorAll('[data-bb-plan]').forEach(function (b) {
      b.setAttribute('aria-selected', b.dataset.bbPlan === plan);
    });

    document.querySelectorAll('[data-bb-qty]').forEach(function (o) {
      var q = +o.dataset.bbQty, k = D[q];
      if (!k) return;
      var t = plan === 'sub' && k.plan != null ? k.plan : k.once;
      o.setAttribute('aria-selected', q === qty);
      var per = o.querySelector('[data-bb-per]');
      var tot = o.querySelector('[data-bb-total]');
      var cad = o.querySelector('[data-bb-cad]');
      if (per) per.textContent = usd(t / q) + ' a bottle';
      if (tot) tot.innerHTML = (plan === 'sub' && k.plan != null
        ? '<s>' + usd(k.once) + '</s> ' : '') + usd(t) + ' total';
      if (cad) cad.textContent = plan === 'sub' && k.days
        ? 'Ships every ' + k.days + ' days'
        : (k.ship ? '+ ' + usd(k.ship) + ' shipping' : 'Free shipping');
    });

    var open = 0;
    GIFTS.forEach(function (g) {
      var need = plan === 'sub' ? g.needSub : g.needOnce;
      if (typeof need === 'number' && need > 0 && qty >= need) open++;
    });
    var gl = document.getElementById('bb-gifts');
    if (gl) gl.textContent = open
      ? '+ ' + open + ' free gift' + (open > 1 ? 's' : '') + ' with this order'
      : '';

    var lab = document.getElementById('bb-label');
    if (lab) lab.textContent = plan === 'sub' ? 'Start the plan' : 'Add to cart';
    var sub = document.getElementById('bb-sub');
    if (sub) sub.textContent = bottles(qty) + ' · ' + usd(total / qty) + ' a bottle · ' + usd(total / useDays) + ' a day';

    var terms = document.getElementById('bb-terms');
    if (terms) terms.innerHTML = plan === 'sub'
      ? usd(total) + ' today, then ' + usd(total) + ' every ' + d.days + ' days. <b>Skip, change or cancel anytime.</b>'
      : usd(total) + (d.ship ? ' + ' + usd(d.ship) + ' shipping' : '') + ' today. <b>One shipment. Nothing renews.</b>';
  }

  function say(msg) {
    var t = document.getElementById('bb-terms');
    if (t) t.innerHTML = '<b>' + msg + '</b>';
    return false;
  }

  /* Comprar SUBSTITUI o carrinho, nao soma (assets/carrinho-substitui.js):
     esvazia antes de adicionar e ignora o toque duplo. Sem aquele arquivo na
     pagina, compra como antes — o fetch direto. */
  function adicionar(items) {
    var cs = typeof window !== 'undefined' && window.carrinhoSubstitui;
    if (cs) return cs.adicionar(items);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); });
  }

  function buy(ev) {
    if (ev) ev.preventDefault();
    var d = D[qty];
    if (!d) return say('Pick a size');
    if (plan === 'sub' && !d.planId) return say('Subscription unavailable for this size');

    var line = { id: d.variantId, quantity: 1 };
    if (plan === 'sub') line.selling_plan = d.planId;
    var lines = [line];
    GIFTS.forEach(function (g) {
      var need = plan === 'sub' ? g.needSub : g.needOnce;
      if (typeof need === 'number' && need > 0 && qty >= need) {
        /* nada de link de download na linha: apareceria no carrinho e no
           checkout, antes do pagamento. Entrega e no e-mail de confirmacao. */
        lines.push({ id: g.variantId, quantity: 1 });
      }
    });

    var btn = document.getElementById('bb-buy');
    if (btn) btn.setAttribute('aria-busy', 'true');
    adicionar(lines)
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (e) {
        if (btn) btn.removeAttribute('aria-busy');
        console.error('[beneo-buybox] /cart/add.js falhou', e);
        say((e && e.description) || 'Could not add to cart — try again');
      });
  }

  function init() {
    if (!read()) return;
    document.querySelectorAll('[data-bb-plan]').forEach(function (b) {
      b.addEventListener('click', function () { plan = b.dataset.bbPlan; render(); });
    });
    document.querySelectorAll('[data-bb-qty]').forEach(function (o) {
      o.addEventListener('click', function () { qty = +o.dataset.bbQty; render(); });
    });
    var b = document.getElementById('bb-buy');
    if (b) b.addEventListener('click', buy);
    /* Voltou do checkout pelo "voltar" (pagina restaurada do bfcache): o botao
       ficou com aria-busy, e o CSS dele (.bn-pdp-cta) corta o clique nesse
       estado. Sem isto o botao ficaria morto. */
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('pageshow', function (e) {
        if (e.persisted && b) b.removeAttribute('aria-busy');
      });
    }
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
